import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';
import i18n from '../i18n';
import { faGlobeEurope } from '@fortawesome/free-solid-svg-icons';

export const ChangeLanguageComponent = ({ languages }: { languages: string[] }) => {
    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value);
    };
    return (
        <div className='d-flex text-nowrap justify-content-start align-items-center text-center w-75 me-2'>
            <FontAwesomeIcon size='lg' icon={faGlobeEurope} className='fa-fw me-2'></FontAwesomeIcon>
            <Form.Select
                size='sm'
                aria-label='Default select example'
                className='w-25'
                defaultValue={i18n.language}
                onChange={(e) => handleSelect(e)}
            >
                {languages.map((language, index) => (
                    <option key={index} value={language}>
                        {language}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
};
